export default "__VITE_ASSET__CAeHXrNO__"